import appStoreModule from './app'

export const useAppStore = appStoreModule
